import * as React from 'react';

import { ENGLISH } from '../../utils/languageList'
import { ConceptExplanation } from '../../components/feedback/conceptExplanation';
import { ReadAloudSource } from '../../components/readAloud/readAloudSource';
import { conceptFeedbackSource } from '../speech/clipSource';
import { defaultLanguages } from '../../utils/languageList.js'
import { languageToLocale } from '../..';

export const getlanguageOptions = (translations) => ([
  { value: ENGLISH, label: ENGLISH },
  ...Object.keys(translations).map(language => ({
    value: language,
    label: language
  }))
]);

interface renderSaveAndExitArguments {
  isELLDiagnostic: boolean,
  language: string,
  languageOptions?: { label: string, value: string }[],
  translate: (language: string) => string
}

export function renderSaveAndExitButton({ isELLDiagnostic, language, languageOptions, translate }: renderSaveAndExitArguments) {
  const languages = isELLDiagnostic ? defaultLanguages : languageOptions?.map(option => option.value)
  let buttonText = 'Save and Exit'
  let lang
  if (language && language !== ENGLISH && languages && languages.includes(language)) {
    buttonText = translate('buttons^save and exit')
    lang = languageToLocale[language]
  }
  return <a className="quill-button medium outlined green focus-on-dark" href={`${window.postbuildEnv.DEFAULT_URL}/profile`} lang={lang}>{buttonText}</a>
}

export const showTranslations = (language, languageOptions): boolean => {
  const permittedLanguages = JSON.parse(window.postbuildEnv.PERMITTED_LANGUAGES)
  return !!languageOptions && !!language && Object.keys(languageOptions).length > 1 && permittedLanguages.includes(language);
};

const getTranslatedConceptsFeedbackData = (key, conceptsFeedback, showTranslation) => {
  return showTranslation && conceptsFeedback?.translated_data ? conceptsFeedback.translated_data[key] : null
}

export const renderExplanation = ({ activityType, data, key, conceptsFeedback, showTranslation, languageLocale }: { activityType: string, data: any, key: string, conceptsFeedback: any, showTranslation?: boolean, languageLocale?: string }) => {
  if (!data) return null;
  const translatedData = getTranslatedConceptsFeedbackData(key, conceptsFeedback, showTranslation);
  return (
    <ReadAloudSource source={conceptFeedbackSource(activityType, key)}>
      <ConceptExplanation {...data} languageLocale={languageLocale} translatedExplanation={translatedData} />
    </ReadAloudSource>
  );
};
